// TODO(A): thư viện SOP / hướng dẫn / video thật khi có dữ liệu. Số MẪU theo script board Mint-Training (LIB), neo 22/Oct/2026.

export type DocType = 'SOP' | 'Hướng dẫn' | 'Video';

export interface LibDoc {
  id: number;
  k: string;
  type: DocType;
  dept: string;
  upd: string;
  /** tooltip dòng tài liệu */
  sub: string;
  /** đã có bài kiểm tra sinh từ tài liệu */
  hasQuiz: boolean;
}

export const LIB: readonly LibDoc[] = [
  { id: 0, k: 'SOP-CS-07 · Gửi bill qua hệ thống', type: 'SOP', dept: 'CS · BKG', upd: '20/Oct/2026', sub: 'Draft chặn khi Telex/Surrender thiếu LOI đúng hãng', hasQuiz: true },
  { id: 1, k: 'SOP-BKG-03 · Request List & mail chung info@', type: 'SOP', dept: 'Booking', upd: '22/Oct/2026', sub: 'Chủ job theo khách, điều phối mail theo lịch', hasQuiz: true },
  { id: 2, k: 'SOP-ACC-11 · Nhập chi phí & phiếu gộp', type: 'SOP', dept: 'OPS · Kế toán', upd: '18/Oct/2026', sub: 'Có HĐ / không HĐ / chi hộ, ảnh chứng từ', hasQuiz: false },
  { id: 3, k: 'Hướng dẫn HANA Ezy mobile · chụp chứng từ', type: 'Hướng dẫn', dept: 'Toàn công ty', upd: '12/Oct/2026', sub: 'Khung chụp, tự cắt, kiểm mờ/tối/lóa', hasQuiz: false },
  { id: 4, k: 'An toàn lái xe container đêm', type: 'Video', dept: 'Vận tải', upd: '05/Oct/2026', sub: 'Video 14 phút · dành cho tài xế', hasQuiz: true },
  { id: 5, k: 'Quy trình ảnh ePOD trên HANA Mov', type: 'Video', dept: 'Vận tải', upd: '03/Oct/2026', sub: 'Video 6 phút', hasQuiz: false },
  { id: 6, k: 'DEM/DET: free time 2 lớp & báo khách', type: 'Hướng dẫn', dept: 'CS', upd: '28/Sep/2026', sub: 'Đếm ngày, báo trước 2 ngày làm việc', hasQuiz: false },
  { id: 7, k: 'Release B/L theo mức nợ', type: 'SOP', dept: 'CS · Kinh doanh', upd: '22/Oct/2026', sub: 'Đường duyệt theo ghế: Trưởng KD / ACC-CA / BOD', hasQuiz: true },
];

export const DOC_TYPES: readonly DocType[] = ['SOP', 'Hướng dẫn', 'Video'];

export function filterLib(docs: readonly LibDoc[], type: DocType | 'all', q: string): LibDoc[] {
  const n = q.trim().toLowerCase();
  return docs.filter((d) => (type === 'all' || d.type === type) && (!n || d.k.toLowerCase().includes(n)));
}

export function countByType(docs: readonly LibDoc[], type: DocType | 'all'): number {
  return type === 'all' ? docs.length : docs.filter((d) => d.type === type).length;
}
